const Rails = require("@rails/ujs")
Rails.start()
window.Rails = Rails
require("@hotwired/turbo-rails")
// Required IMMEDIATELY after turbo-rails so its `turbo:before-render`
// listener attaches before any user navigation can happen — pages
// like /dashboard rely on it to keep leaked legacy Bootstrap CSS
// from accumulating into subsequent app-shell pages.
require("packs/turbo_head_pruner")
import "controllers"
require("packs/job_title_clicks")
// Keyboard navigation for job cards
require("packs/job_card_keyboard_navigation")
// Job pages + Turbo-frame sidebar interactions (share/copy/etc.)
require("packs/positivius_job_interactions")

import { bindJobWorldView } from "../home/job_world_view"

document.addEventListener("DOMContentLoaded", bindJobWorldView)
document.addEventListener("turbo:load", bindJobWorldView)

function initHeaderScroll() {
    const header = document.querySelector('.modern-header');
    if (!header) return;
    let ticking = false;
    function getScrollTop() {
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }
    function updateHeader() {
        const scrollY = getScrollTop();
        if (scrollY > 10) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
        ticking = false;
    }
    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(updateHeader);
            ticking = true;
        }
    }
    window.removeEventListener('scroll', requestTick);
    window.addEventListener('scroll', requestTick, { passive: true });
    updateHeader();
}
document.addEventListener('DOMContentLoaded', initHeaderScroll);
document.addEventListener('turbo:load', initHeaderScroll);
document.addEventListener('turbo:render', initHeaderScroll);

// WebMCP Support - Expose site tools to AI agents
function initWebMCP() {
  if (!navigator.modelContext) {
    return;
  }

  const baseUrl = window.location.origin;
  const fetchToolResponse = async (path) => {
    const response = await fetch(`${baseUrl}${path}`, {
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      return await response.json();
    }
    return { text: await response.text() };
  };

  // Define tools for AI agents
  const tools = [
    {
      name: 'search_jobs',
      description: 'Search for AI and tech jobs with filters for tags, location, and salary',
      inputSchema: {
        type: 'object',
        properties: {
          query: { type: 'string', description: 'Search query for job titles or keywords' },
          tags: { type: 'array', items: { type: 'string' }, description: 'Job tags to filter by (e.g., python, remote, ai-engineer)' },
          location: { type: 'string', description: 'Location filter (e.g., remote, New York, London)' },
          salary_min: { type: 'integer', description: 'Minimum annual salary in USD' }
        }
      },
      execute: async (input) => {
        try {
          const params = new URLSearchParams();
          if (input.query) params.append('query', input.query);
          if (input.tags && input.tags.length) params.append('tag', input.tags.join('+'));
          if (input.location) params.append('location', input.location);
          if (input.salary_min) params.append('salary', input.salary_min);
          const query = params.toString();
          const endpoint = query ? `/ai-jobs/search?${query}` : '/ai-jobs/search';
          return await fetchToolResponse(endpoint);
        } catch (error) {
          console.error('Error in search_jobs tool:', error);
          throw error;
        }
      }
    },
    {
      name: 'get_job_details',
      description: 'Get detailed information about a specific job posting',
      inputSchema: {
        type: 'object',
        properties: {
          job_id: { type: 'string', description: 'Job ID or slug' }
        },
        required: ['job_id']
      },
      execute: async (input) => {
        try {
          return await fetchToolResponse(`/jobs/${input.job_id}`);
        } catch (error) {
          console.error('Error in get_job_details tool:', error);
          throw error;
        }
      }
    },
    {
      name: 'get_companies',
      description: 'Get list of AI and tech companies hiring',
      inputSchema: {
        type: 'object',
        properties: {
          tag: { type: 'string', description: 'Filter by tag (e.g., ai, ml, data-science)' },
          sort: { type: 'string', description: 'Sort order (e.g., top-growing)' }
        }
      },
      execute: async (input) => {
        try {
          const params = new URLSearchParams();
          if (input.tag) params.append('tag', input.tag);
          if (input.sort) params.append('sort', input.sort);
          const query = params.toString();
          const endpoint = query ? `/ai-companies?${query}` : '/ai-companies';
          return await fetchToolResponse(endpoint);
        } catch (error) {
          console.error('Error in get_companies tool:', error);
          throw error;
        }
      }
    },
    {
      name: 'get_company_details',
      description: 'Get detailed information about a specific company',
      inputSchema: {
        type: 'object',
        properties: {
          company_slug: { type: 'string', description: 'Company slug or identifier' }
        },
        required: ['company_slug']
      },
      execute: async (input) => {
        try {
          return await fetchToolResponse(`/ai-companies/${input.company_slug}`);
        } catch (error) {
          console.error('Error in get_company_details tool:', error);
          throw error;
        }
      }
    },
    {
      name: 'get_salary_data',
      description: 'Get salary data and market trends for AI/tech roles',
      inputSchema: {
        type: 'object',
        properties: {
          role: { type: 'string', description: 'Job role or title (e.g., ai-engineer, data-scientist)' },
          location: { type: 'string', description: 'Location filter (e.g., remote, US, Europe)' }
        }
      },
      execute: async (input) => {
        try {
          const params = new URLSearchParams();
          if (input.role) params.append('role', input.role);
          if (input.location) params.append('location', input.location);
          const query = params.toString();
          const endpoint = query ? `/ai-salaries?${query}` : '/ai-salaries';
          return await fetchToolResponse(endpoint);
        } catch (error) {
          console.error('Error in get_salary_data tool:', error);
          throw error;
        }
      }
    }
  ];

  // Register tools with WebMCP
  try {
    navigator.modelContext.provideContext({
      tools: tools
    });
    console.log('WebMCP tools registered successfully');
  } catch (error) {
    console.log('WebMCP not available or error registering tools:', error);
  }
}

document.addEventListener('turbo:load', initWebMCP);
